import classNames from 'classnames'
import React from 'react'

const Account: React.FC<{ className?: string }> = ({ className }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
		<path
			className={classNames(className ?? 'fill-brand-primary-md')}
			fillRule="evenodd"
			d="M6.333 7.333A5.01 5.01 0 017.7 3.876 4.562 4.562 0 0111 2.445c1.238 0 2.425.515 3.3 1.431a5.01 5.01 0 011.367 3.457A5.01 5.01 0 0114.3 10.79a4.562 4.562 0 01-3.3 1.432 4.562 4.562 0 01-3.3-1.432 5.01 5.01 0 01-1.367-3.457zm9.128 5.65a7.376 7.376 0 002.29-3.715c.38-1.455.323-2.999-.165-4.419a7.304 7.304 0 00-2.561-3.515A6.783 6.783 0 0010.998 0C9.56 0 8.153.466 6.974 1.334a7.304 7.304 0 00-2.56 3.515 7.665 7.665 0 00-.166 4.42 7.376 7.376 0 002.29 3.715C2.816 14.356.5 17.413.5 20.778c0 .324.123.635.342.864.219.23.515.358.825.358.31 0 .606-.129.825-.358.218-.23.341-.54.341-.864 0-2.775 2.748-6.111 8.167-6.111 5.42 0 8.167 3.336 8.167 6.11 0 .325.123.636.341.865.22.23.516.358.825.358.31 0 .607-.129.825-.358.22-.23.342-.54.342-.864 0-3.365-2.315-6.422-6.039-7.794z"
			clipRule="evenodd"
		/>
	</svg>
)

export default Account
